import { render, staticRenderFns } from "./ClientCreditsRecord.vue?vue&type=template&id=5d3a0936"
import script from "./ClientCreditsRecord.vue?vue&type=script&lang=js"
export * from "./ClientCreditsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3a0936')) {
      api.createRecord('5d3a0936', component.options)
    } else {
      api.reload('5d3a0936', component.options)
    }
    module.hot.accept("./ClientCreditsRecord.vue?vue&type=template&id=5d3a0936", function () {
      api.rerender('5d3a0936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientCreditsRecord.vue"
export default component.exports